const MagnifyingGlassDark = () => (
  <svg
    fill="none"
    height="64"
    viewBox="0 0 64 64"
    width="64"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M31.8756 36.1069L30.034 34.1028C28.8929 32.8609 26.991 32.8068 25.786 33.9819L10.5002 48.8896C9.29528 50.0647 9.24348 52.0242 10.3847 53.2661L12.2262 55.2702C13.3674 56.5121 15.2693 56.5662 16.4743 55.3911L31.76 40.4834C32.965 39.3083 33.0167 37.3488 31.8756 36.1069Z"
      fill="url(#paint0_linear_4622_25940)"
    />
    <path
      d="M42.3052 39.6531C50.6783 39.6549 57.4647 32.6633 57.4629 24.0368C57.4611 15.4104 50.6719 8.41585 42.2988 8.41406C33.9257 8.41227 27.1393 15.4039 27.1411 24.0304C27.1429 32.6568 33.9321 39.6513 42.3052 39.6531Z"
      fill="url(#paint1_linear_4622_25940)"
    />
    <path
      d="M42.3042 35.2012C48.2908 35.2024 53.1428 30.2036 53.1415 24.036C53.1402 17.8683 48.2862 12.8675 42.2996 12.8662C36.3131 12.8649 31.4611 17.8637 31.4624 24.0313C31.4636 30.199 36.3177 35.1999 42.3042 35.2012Z"
      fill="url(#paint2_linear_4622_25940)"
    />
    <path
      d="M30.3064 41.7244L24.3993 35.6387L21.293 38.839L27.2001 44.9247L30.3064 41.7244Z"
      fill="url(#paint3_linear_4622_25940)"
    />
    <path
      d="M22.1981 49.7452L16.1561 43.5205L13.0498 46.7208L19.0917 52.9455L22.1981 49.7452Z"
      fill="url(#paint4_linear_4622_25940)"
    />
    <path
      clipRule="evenodd"
      d="M33.5065 38.0099C36.1465 39.7675 39.1866 40.6518 42.2357 40.6524L42.2358 40.6617C46.203 40.6626 50.1699 39.1576 53.2741 36.1372C59.7094 29.8627 59.9887 19.3687 53.8957 12.7362C47.8027 6.10358 37.6167 5.81146 31.1815 12.0859C25.7032 17.4273 24.6861 25.8267 28.2637 32.2985C28.1376 32.2824 28.01 32.2725 27.8813 32.269C26.8282 32.2313 25.8478 32.6333 25.0854 33.372L9.80049 48.2774C8.23026 49.811 8.16723 52.3643 9.64739 53.9827L11.4816 55.9847C12.2444 56.8266 13.2885 57.2477 14.3234 57.2479C15.2857 57.2481 16.257 56.8836 17.0104 56.1449L19.3182 53.8944C19.439 53.8506 19.552 53.7791 19.6515 53.6766L21.598 51.6712L27.6778 45.7423C27.7085 45.7179 27.738 45.6913 27.7659 45.6625L27.877 45.548L32.2953 41.2394C33.184 40.3715 33.5899 39.1768 33.5065 38.0099ZM22.1635 48.55L25.8194 44.985L20.9576 39.9762L17.3018 43.5413L22.1635 48.55ZM12.7975 47.9338L11.0445 49.6432C10.2004 50.4661 10.1644 51.8316 10.9635 52.7016L12.7977 54.7036C13.5968 55.5736 14.9222 55.6113 15.7663 54.7884L17.6592 52.9425L12.7975 47.9338ZM20.3553 50.3134L18.9788 51.6557L14.2576 46.7916L16.0729 44.9214L20.8309 49.8234L20.3553 50.3134ZM31.0512 39.883L30.3284 40.5879L25.4666 35.5792L26.3294 34.7378C26.7379 34.3451 27.2644 34.1488 27.8272 34.1489C28.3901 34.1584 28.9167 34.4017 29.2981 34.8226L31.1323 36.8246C31.5137 37.2362 31.7226 37.788 31.7046 38.3679C31.6956 38.9478 31.4597 39.4902 31.0512 39.883ZM32.4255 13.4424C35.1757 10.7587 38.6978 9.4313 42.2202 9.43205C45.9968 9.43286 49.7737 10.9676 52.5705 14.0172C57.9734 19.8921 57.7302 29.2076 52.021 34.7714C46.321 40.3353 37.2788 40.0808 31.876 34.1966C26.4731 28.3218 26.7163 19.0062 32.4255 13.4424ZM42.2258 36.2092C39.1119 36.2085 35.9977 34.9452 33.6913 32.4288C29.2328 27.583 29.4401 19.9042 34.1418 15.3129C38.8434 10.7215 46.2968 10.9383 50.7552 15.7841C55.2138 20.6299 55.0066 28.3086 50.3049 32.9C48.0358 35.1068 45.1309 36.2098 42.2349 36.2092H42.2258ZM42.2211 13.8742C39.7701 13.8737 37.31 14.7991 35.3949 16.6693C31.4194 20.55 31.2482 27.0409 35.0166 31.1383C38.7849 35.2358 45.0854 35.4148 49.0609 31.5342C53.0364 27.6535 53.2076 21.1626 49.4392 17.0651C47.4869 14.9416 44.854 13.8654 42.2211 13.8649V13.8742ZM48.9752 28.0265L49.0841 27.8314C50.1095 25.9943 50.4114 23.8443 49.9379 21.7732C49.8217 21.2703 49.3373 20.9593 48.8515 21.0811C48.3657 21.2028 48.0641 21.7056 48.1803 22.2085C48.5685 23.871 48.3039 25.5988 47.431 27.0502C46.566 28.5063 45.2071 29.5373 43.598 29.9312C43.1122 30.053 42.8106 30.5558 42.9268 31.0587C43.043 31.5616 43.5275 31.8726 44.0133 31.7508C46.0958 31.2386 47.8495 29.9122 48.9752 28.0265ZM22.499 38.9085L27.1209 43.6702L28.9362 41.8L24.3143 37.0383L22.499 38.9085Z"
      fill="#121112"
      fillRule="evenodd"
    />
    <defs>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint0_linear_4622_25940"
        x1="31.8613"
        x2="22.3967"
        y1="56.1682"
        y2="29.0223"
      >
        <stop offset="0.251475" stopColor="#FF6D4E" />
        <stop offset="0.642242" stopColor="#FED7FF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint1_linear_4622_25940"
        x1="42.3053"
        x2="42.3126"
        y1="39.653"
        y2="5.68267"
      >
        <stop offset="0.239141" stopColor="#FFD43E" />
        <stop offset="1" stopColor="#FF6D4E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint2_linear_4622_25940"
        x1="47.494"
        x2="36.5387"
        y1="35.202"
        y2="13.1489"
      >
        <stop offset="0.239571" stopColor="#A0DCFF" />
        <stop offset="0.845111" stopColor="#56BB6C" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint3_linear_4622_25940"
        x1="28.7434"
        x2="27.4202"
        y1="43.3347"
        y2="36.3624"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint4_linear_4622_25940"
        x1="20.5777"
        x2="19.5143"
        y1="51.415"
        y2="44.3244"
      >
        <stop offset="0.13" stopColor="#56BB6C" />
        <stop offset="0.69417" stopColor="#E1EB3B" />
        <stop offset="1" stopColor="#FFD43E" />
      </linearGradient>
    </defs>
  </svg>
)

export default MagnifyingGlassDark
